define('lq/events/actions/update',[
    'lq/events/actions/eventAction',
    'jquery',
    'underscore',
    'lq/uploader',
    'lq/entityFiltersState',
    'lq',
    'lq/events/abortError',
    'when'
], function (EventAction, $, _, Uploader, entityFiltersState, lq, AbortError, when) {
    'use strict';

    function Update(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(Update, EventAction);

    Update.typeName = 'Update';

    Update.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    Update.prototype.createEventActionRequest = function () {
        var commandViewModelKeysValues = {};

        var self = this;
        _.each(self.eventData.commandViewModelKeys, function (key) {
            var drop = self.piping.dropFactory.findDropByViewModelKey(key);
            if(!drop)
                throw 'Cannot find drop : "' + key + '" for update command.';
            self.checkRequired(drop);

            var value = drop.getValue();
            commandViewModelKeysValues[key] = value;
        });

        var extraProperties = {};

        if (self.eventData.isEntityFilterEntity)
            extraProperties['Filter'] = entityFiltersState.getStateOfEntityFilters(this.rootDrop);

        var request = {
            eventActionType: "Update",
            command: self.eventData.command,
            commandViewModelKeys: commandViewModelKeysValues,
            uploads: [],
            extraProperties: extraProperties,
            captcha: this.getCaptcha()
        };

        if (self.eventData.fileUploadType === null)
            return request;

        if (self.eventData.fileUploadType === 'fromViewModel') {
            var drop = self.piping.dropFactory.findDropByViewModelKey(self.eventData.fileSourceMorph);
            self.checkRequired(drop);
            return function (requestContinuation) {
                when(drop.getFile())
                    .then(function (content) {
                        $.ajax({
                            type: 'POST',
                            url: lq.getTenantUrl('DynamicContent/AddPromptlessTempFile'),
                            contentType: "application/json; charset=utf-8",
                            data: content,
                            dataType: 'json'
                        }).done(function (response) {
                            if (response.success) {
                                request.uploads.push(
                                    {
                                        fileName: response.fileName,
                                        tempUrl: response.tempUrl
                                    });
                                requestContinuation(request);
                            };
                        });
                    });               
            };
        } else if (self.eventData.fileUploadType === 'fromParameter') {
            return function (requestContinuation) {
                var file = self.piping.parameters.getValue(self.eventData.fileSourceParameter);
                var xhr = new XMLHttpRequest();
                var fd = new FormData();
                var url = lq.getTenantUrl('DynamicContent/AddTempFile');
                xhr.open("POST", url, true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState !== 4)
                        return;
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        request.uploads.push(
                            {
                                fileName: response.fileName,
                                tempUrl: response.tempUrl
                            });
                        requestContinuation(request);
                    }
                };
                fd.append("qqfile", file);
                xhr.send(fd);
            };
        } else {
            return function (requestContinuation) {
                var uploader = new Uploader(self.piping)
                    .toTenantUrl("DynamicContent/AddTempFile")
                    .withFileFilter(self.eventData.fileUploadAllowedFileTypes === 'custom' ?
                        self.eventData.fileUploadAllowedCustomFileTypes : self.eventData.fileUploadAllowedFileTypes)
                    .withMaxFileSize(self.eventData.maxFileSize)
                    .withSmartphoneMode(self.eventData.fileUploadModeSmartPhone)
                    .withPhotoQuality(self.eventData.photoQuality)
                    .withMaxImageDimensions(self.eventData.maxImageDimensions)
                    .onFileUploaded(function (uploadResponse) {
                        if (!uploadResponse.success)
                            throw new Error('Upload failed.');

                        request.uploads.push(
                        {
                            fileName: uploadResponse.filename,
                            tempUrl: uploadResponse.tempUrl
                        });
                    })
                    .onUploadFinished(function () {
                        requestContinuation(request);
                    });
                if (self.eventIsEnabled('maxFileSizeExceeded')) {
                    uploader
                        .onMaxFileSizeExceeded(function () {
                            self.triggerEvent('maxFileSizeExceeded');
                        })
                }
                if (self.eventData.fileUploadType === "singleFile" || self.eventData.fileUploadType == "newFile") {
                    uploader.uploadSingleFile();
                }
                else if (self.eventData.fileUploadType === "multipleFiles") {
                    uploader.uploadMultipleFiles();
                }
            };
        }
    };

    Update.prototype.checkRequired = function (drop) {
        if (!this.eventData.skipRequiredFields && drop.isVisible() && !drop.isValid()) {
            if (this.eventIsEnabled('requiredFieldsMissing')) {
                this.triggerEvent('requiredFieldsMissing');
                throw new AbortError();
            } else {
                alert('* not all required fields are filled in.');
                throw new AbortError();
            }
        }
    };

    Update.prototype.getCaptcha = function () {
        if (!this.eventData.captchaField) return null;

        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);

        if (!captchaDrop.data.captchaInputField) return null;

        return this.piping.dropFactory
            .findDropByName(captchaDrop.data.captchaInputField)
            .getValue();;
    };

    return Update;
});
